// extracted by mini-css-extract-plugin
export default {"questionTitle":"OpenEnded_questionTitle__KMWUy","error":"OpenEnded_error__NjjVF","text":"OpenEnded_text__6eHo5"};